import { Compare, Widgets } from '@mui/icons-material';
import React, { forwardRef } from 'react';

export const CompareIcon = forwardRef<SVGSVGElement, React.ComponentProps<typeof Widgets>>((properties, reference) => {
  return <Compare ref={reference} {...properties} />;
});

CompareIcon.displayName = 'CompareIcon';
